.ux-iws-notification-bar {
    display: block;

    &__wrapper {
        background-color: $color-gray-background-dark;
        transition: background-color $animationSpeed-fast $animationEasing-ease;

        * {
            color: $color-black;
        }

        &:hover {
            background-color: $color-gray-background-darker;
        }
    }

    &__wrapper--white {
        background-color: $color-white;

        * {
            color: $color-black;
        }

        &:hover {
            background-color: $color-white;
        }
    }

    &__wrapper--green {
        background-color: $color-green-link;
        color: $color-white;

        * {
            color: $color-white;
        }

        ux-button {
            --ux-button-text-color: $color-white;
            --ux-button-border-color: #fff;
        }

        &:hover {
            background-color: $color-green-82;
        }
    }

    &__wrapper--blue {
        background-color: $color-blue-1;

        * {
            color: $color-white;
        }

        ux-button {
            --ux-button-text-color: $color-white;
            --ux-button-border-color: #fff;
        }

        &:hover {
            background-color: $color-blue-2;
        }
    }

    &__inner-wrapper {
        padding: 30px 0;
        margin: 0 auto;
        display: flex;
        flex-direction: column;

        @media only screen and (min-width: 768px) {
            flex-direction: row;
        }

        @media only screen and (min-width: 1024px) {
            padding: 35px 0 45px;
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        max-width: 100%;

        @media only screen and (min-width: 1024px) {
            flex-direction: row;
            justify-content: space-between;
        }
    }

    &__icon {
        display: block;

        @media only screen and (min-width: 768px) {
            margin-right: 40px;
            margin-top: 5px;
        }
    }

    &__icon ux-icon {
        font-size: 55px;

        @media only screen and (min-width: 768px) {
            font-size: 85px;
        }
    }

    *[slot="title"] {
        line-height: $line-height-small;

        @media only screen and (min-width: 768px) {
            margin-top: 0;
        }

        @media only screen and (min-width: 1920px) {
            font-size: 23px;
        }
    }

    *[slot="copy"] *:last-child {
        @media only screen and (min-width: 1024px) {
            margin-bottom: 0;
        }
    }

    &__cta {
        margin-top: 20px;

        @media only screen and (min-width: 1024px) {
            align-self: flex-end;
            flex: 0 0 auto;
            margin-left: 8%;
            margin-bottom: 5px;
        }
    }
}
